import { Text } from 'components/typo'
import Checkbox from '../Checkbox'
import css from './styles.module.scss'
import classnames from 'classnames/bind'

const cx = classnames.bind(css)

const CheckboxRow = ({ option, isChecked, onMouseDown }) => {
  return (
    <Text
      tag="li"
      theme="gray"
      size="small"
      className={cx(css.option, {
        checked: isChecked,
      })}
      role="option"
      tabIndex="0"
      onMouseDown={onMouseDown}
    >
      <Checkbox isChecked={isChecked} />
      {option}
    </Text>
  )
}

export default CheckboxRow
